import { useContext, useMemo } from 'react';
import identity from 'transmute/identity';
import FormattedMessage from 'I18n/components/FormattedMessage';
import KnowledgePopoverEmptyState from './draft-content-transplant-ka/KnowledgePopoverEmptyState';
import KnowledgePopoverErrorState from './draft-content-transplant-ka/KnowledgePopoverErrorState';
import transformArticlesData from './draft-content-transplant-ka/transformArticlesData';
import GenericPopoverHeader from '../../components/GenericPopoverHeader';
import { ContentContainerV2 } from '../../components/insertMenu/ContentContainer';
import InsertContentDecorator from '../../../draft-transplant/InsertContentDecoratorV2';
import contentOutputs from '../../editorCapabilities/ContentOutputTypes';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import { getKnowledgeUrl } from '../../utils/manageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
const KBArticlesTypeahead = ({
  apiFunctions,
  knowledgeBaseId,
  onChange,
  onClickBack,
  portalId,
  title
}) => {
  const {
    KNOWLEDGE_ARTICLE: {
      onClickManage = undefined,
      onInsertContent = identity,
      onSearchKB = undefined,
      outputType = contentOutputs.RENDERED
    } = {}
  } = useContext(EditorConfigContext);
  const LocalKBArticlesTypeahead = useMemo(() => {
    const insertKnowledgeArticlesDecoratorConfig = {
      outputType,
      apiFunctions,
      mergeTagOptions: {
        includeCustomTokens: true
      }
    };
    return InsertContentDecorator(ContentContainerV2({
      onInsertContent,
      onSearchChange: onSearchKB,
      portalId,
      PopoverErrorState: KnowledgePopoverErrorState,
      PopoverEmptyState: KnowledgePopoverEmptyState,
      searchPlaceHolder: 'hubspot-prosemirror.knowledgeBase.search.placeholder',
      transformData: transformArticlesData,
      search: apiFunctions.searchArticles,
      Header: /*#__PURE__*/_jsx(GenericPopoverHeader, {
        manageUrl: getKnowledgeUrl(portalId, knowledgeBaseId),
        onClickManageButton: onClickManage,
        onViewInsertMenu: onClickBack,
        portalId: portalId,
        titleMessage: title || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.insertMenu.knowledgeArticle"
        })
      }),
      contentKey: 'kbArticles'
    }), insertKnowledgeArticlesDecoratorConfig);
  }, [apiFunctions, knowledgeBaseId, onClickBack, onClickManage, onInsertContent, onSearchKB, outputType, portalId, title]);
  return /*#__PURE__*/_jsx(LocalKBArticlesTypeahead, {
    onChange: onChange,
    useProsemirror: true
  });
};
export default KBArticlesTypeahead;